import { render } from "./Transactions.vue?vue&type=template&id=1119a095&scoped=true&ts=true"
import script from "./Transactions.vue?vue&type=script&lang=ts"
export * from "./Transactions.vue?vue&type=script&lang=ts"

import "./Transactions.vue?vue&type=style&index=0&id=1119a095&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1119a095"]])

export default __exports__